// GET SAA INTERNAL PORTAL QUERY MGMT
export const MANAGE_SAA_QUERY_REQUEST = 'manage_saa_query_request';
export const MANAGE_SAA_QUERY_SUCCESS = 'manage_saa_query_success';
export const MANAGE_SAA_QUERY_FAILURE = 'manage_saa_query_failure';